










import Vue, { PropType } from 'vue'

import { MessageChannel, MesssageChannelAccess } from 'base/store/state.interface'

import ChannelMembersList from './ChannelMembersList.vue'

export default Vue.extend({
  components: {
    ChannelMembersList
  },
  props: {
    channel: {
      type: Object as PropType<MessageChannel>,
      required: true
    }
  },
  computed: {
    membersAccess(): { [ucrId: string]: MesssageChannelAccess; } {
      return this.channel.ucr_access
    }
  }
})
